import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  Person
} from "@mui/icons-material";
import React from 'react';
import SaleInformation from "../SaleInformation";
import { BidHistory } from "../BidHistory";
import CarDetails from '../CarDetails';
import { mainContainer } from '../VehicleInfoSidebarSx';
import { useDispatch, useSelector } from 'react-redux';
import { setAlertDialog } from '../../../../toolkit/alertDialog/alertDialogSlice';
import { parsedVehicle } from '@common/utils/methods/parsedVehicleForCarData';
import { useLocation } from 'react-router-dom';
import { useLazyGetVehicleQuery } from '../../../../toolkit/vehicle/vehicleApi';
import { routes } from '../../../../utils/constants/routes';
import CarDetailSkeleton from '../CarDetailsSkeleton';
import { useLazyGetAuctionHistorySellerQuery, useLazyGetBidHistoryQuery } from '../../../../toolkit/liveAuction/liveAuctionApi';
import { auctionTypes, Bidding_Through, exportAuction, localAuction } from '../../../../utils/constants/auction';
import theme from '../../../../theme';
import { useLazyGetAgentDetailsQuery, useLazyGetSellerDetailsQuery } from '../../../../toolkit/carDetails/carDetailsApi';
import auctionLogo from "../../../../components/assets/auction.svg";
import { sidebarButton } from "../UpcomingCars/UpcomingCarsDetailSx";
import CustomSelect from '../../../../components/ui/CustomSelect';
import { formControl } from './GeneralInfoSx';
import { reducerPaths } from '../../../../app/reducerPaths';
import { getBidHistoryHandler } from '../../../../utils/methods/generalVehicleMethods';
import { CAR_STATUS } from '../../../../utils/constants/carData';
import SellerDetails from '@common/pages/Dashboard/components/SellerDetails';


// Main Car Detail Page component
const MyGarageCarDetail = (
  {
    selectedCarInit,
    // setSelectedCar
  }
) => {

  const auctionAndMarketTypeOptionsInit = React.useMemo(() => {
    return [
      {
        auctionType: auctionTypes.liveAuction,
        marketType: localAuction,
        auctionTypeLabel: "Live Auction",
        marketTypeLabel: "Local Market"
      },
      {
        auctionType: auctionTypes.liveAuction,
        marketType: exportAuction,
        auctionTypeLabel: "Live Auction",
        marketTypeLabel: "Export Market"
      },
      {
        auctionType: auctionTypes.buyNow,
        marketType: localAuction,
        auctionTypeLabel: "Buy Now",
        marketTypeLabel: "Local Market"
      },
      {
        auctionType: auctionTypes.buyNow,
        marketType: exportAuction,
        auctionTypeLabel: "Buy Now",
        marketTypeLabel: "Export Market"
      }
    ]
  }, []);

  const isMobile = useMediaQuery("(max-width:1300px)");

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.myGarage}/`)?.[1];

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const buyNow = useSelector(store => store[reducerPaths.buyNow]);
  // useSelector end...

  // useState variables start...
  const [selectedCar, setSelectedCar] = React.useState(selectedCarInit);
  const [sellerDetails, setSellerDetails] = React.useState(null);
  const [viewAuctionBidHistory, setViewAuctionBidHistory] = React.useState(false);
  const [auctionAndMarketTypeOptions, setAuctionAndMarketTypeOptions] = React.useState(
    auctionAndMarketTypeOptionsInit?.filter(item => {

      if (item.marketType !== selectedCar?.auction_type) {
        return false;
      }

      if (item.auctionType === auctionTypes.liveAuction && !selectedCar?.Live_Auction_DateTime) {
        return false;
      } else if (item.auctionType === auctionTypes.buyNow && !selectedCar?.Buy_now_DateTime) {
        return false;
      }

      return true;
    })
  );
  const [auctionAndMarketType, setAuctionAndMarketType] = React.useState(null);
  const [isSellerDetailsModalOpen, setIsSellerDetailsModalOpen] = React.useState(false);
  // useState variables end...

  // Handlers start...
  // Handlers end...

  // custom hooks start...
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getAuctionHistorySellerApiHandler, getAuctionHistorySellerApiData] = useLazyGetAuctionHistorySellerQuery();
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  const [getAgentDetailsApiHandler, getAgentDetailsApiData] = useLazyGetAgentDetailsQuery();
  const [getSellerDetailsApiHandler, getSellerDetailsApiData] = useLazyGetSellerDetailsQuery();
  // const { data: sellerDetails, isFetching } = useGetSellerDetailsQuery({
  //   vehicleId: Vehicle_Id,
  // });
  // custom hooks end...

  const bidHistory = auctionAndMarketTypeOptions?.length > 0  && auctionAndMarketType >= 0 ? getBidHistoryHandler({
    getBidHistoryApiData,
    auctionType: auctionAndMarketTypeOptions[auctionAndMarketType]?.auctionType === auctionTypes.liveAuction ? Bidding_Through.Auction : Bidding_Through.BuyNow
  }) : [];

  // useEffect start...
  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error || res?.error?.data?.message || `Some error occured!`,
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      await getAuctionHistorySellerApiHandler({
        Vehicle_Id,
      });
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      await getBidHistoryApiHandler({
        vehicleId: selectedCar?.Vehicle_Id
      });
    })();
  }, [selectedCar?.Vehicle_Id]);

  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getAgentDetailsApiHandler({
          vehicleId: Vehicle_Id
        });

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: `Error`,
              message: res?.error?.data?.error ||
                res?.error?.data?.message || `Some error occured!`
            })
          );
        }
      })();
    }
  }, [Vehicle_Id]);


  React.useEffect(() => {
    const auctionAndMarketTypeOptionsTemp = auctionAndMarketTypeOptionsInit?.filter(item => {
      if (item.marketType !== selectedCar?.auction_type) {
        return false;
      }

      if (item.auctionType === auctionTypes.liveAuction && !selectedCar?.Live_Auction_DateTime) {
        return false;
      } else if (item.auctionType === auctionTypes.buyNow && !selectedCar?.Buy_now_DateTime) {
        return false;
      }

      return true;
    });
    setAuctionAndMarketTypeOptions(auctionAndMarketTypeOptionsTemp);

    setAuctionAndMarketType(
      auctionAndMarketTypeOptionsTemp?.length > 0 ? 0 : null
    )
  }, [
    selectedCar
  ]);

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }

    (async () => {
      const res = await getBidHistoryApiHandler({
        vehicleId: selectedCar?.Vehicle_Id,
      });

      if (res?.error) {
        dispatch(
          setAlertDialog({
            open: true,
            title: `Error!`,
            message: res?.error?.data?.message || res?.error?.data?.error || `Some error occured!`,
          })
        );
      }
    })();
  }, [selectedCar?.Vehicle_Id]);

  React.useEffect(() => {

    if (!Vehicle_Id) {
      return;
    }

    console.log("getSellerDetailsApiHandler");

    (async () => {
      const res = await getSellerDetailsApiHandler({
        vehicleId: Vehicle_Id
      });

      console.log(res, "getSellerDetailsApiHandler");

      setSellerDetails(res?.data);
    })();
  }, [Vehicle_Id]);
  // useEffect end...

  console.log(auctionAndMarketType, "MyGarageCarDetail")

  return (
    <Grid
      container
      spacing={2}
      sx={mainContainer}
    >
      {/* Left sidebar with buttons */}
      {auctionAndMarketTypeOptions?.length > 0 ? <Grid 
        item
        sx={{
          width: isMobile ? "100%" : "28.5%"
        }}
      >
        <Box display={"flex"} flexDirection="column" gap={2}>

          {/* {getAuctionHistorySellerApiData?.data?.auctions?.length > 0 ? (
            <Box>
              <Button
                variant="contained"
                fullWidth
                startIcon={<img src={auctionLogo} />}
                sx={sidebarButton}
                onClick={() => {
                  setViewAuctionBidHistory(true);
                }}
              >
                Previous Auctions
              </Button>
            </Box>
          ) : null} */}

          <Button
            variant="outlined"
            startIcon={<Person />}
            onClick={() => {
              setIsSellerDetailsModalOpen(true);
            }}
            sx={{
              width: '100%',
              height: 64,
              fontSize: '1.1rem',
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: 3,
              borderWidth: 2,
              borderColor: '#2563eb',
              color: '#2563eb',
              backgroundColor: 'white',
              // marginBottom: '1rem',
              '&:hover': {
                borderWidth: 2,
                borderColor: '#1d4ed8',
                backgroundColor: '#f8fafc',
              },
              '& .MuiButton-startIcon': {
                marginRight: 2,
              },
            }}
          >
            View Seller Details
          </Button>

          {selectedCar?.car_label_status !== CAR_STATUS.SOLD_CAR ? <FormControl fullWidth size="small" sx={formControl}>
            <CustomSelect
              name="auctionAndMarketType"
              fullWidth
              value={auctionAndMarketType}
              onChange={(e) => {
                setAuctionAndMarketType(e?.target?.value);
              }}
              sx={{
                height: "2.5rem",
                fontFamily: theme.typography.fontFamily,
                width: "100%",
              }}
              options={
                auctionAndMarketTypeOptions?.map?.(
                  (item, itemIdx) => {
                    return {
                      label: `${item?.auctionTypeLabel} - ${item?.marketTypeLabel}`,
                      value: itemIdx
                    }
                  }
                )
              }
            />
          </FormControl> : null}

          <BidHistory 
            selectedCar={selectedCar}
            bids={
              bidHistory
            } 
            isLoading={getBidHistoryApiData?.isLoading}
          />

          <SaleInformation
            data={{ 
              ...(getAgentDetailsApiData?.data?.[0] || {}),
              address: selectedCar?.Location,
              date: selectedCar?.Live_Auction_DateTime
            }}
            car={selectedCar}
          />
        </Box>
      </Grid> : null}

      {/* Right Section - 70% */}
      <Grid width={isMobile  || auctionAndMarketTypeOptions?.length === 0 ? "100%" : "70%"}>
        <CarDetails
          car={parsedVehicle(selectedCar)} 
          showEdit 
        />
      </Grid>
      {/* Main content area */}

      {isSellerDetailsModalOpen ? (
        <Modal
          open={true}
          onClose={() => {
            setIsSellerDetailsModalOpen(false);
          }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '30%',
              minWidth: '500px',
              maxWidth: '1000px',
              maxHeight: '1000px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {getSellerDetailsApiData?.isFetching ? <CircularProgress size={60} /> : <SellerDetails data={sellerDetails?.seller} />}
            {/* {isFetching ? <CircularProgress size={60} /> : <SellerDetails data={sellerDetails?.seller} />} */}
          </Box>
        </Modal>
      ) : null}
    </Grid>
  );
};

export default MyGarageCarDetail;
